import y from "./ghl-ui.es1589.js";
import w from "./ghl-ui.es1590.js";
import l from "./ghl-ui.es1586.js";
import h from "./ghl-ui.es1587.js";
import m from "./ghl-ui.es1588.js";
import d from "./ghl-ui.es1591.js";
import { Parser as v } from "./ghl-ui.es1670.js";
import { mapValue as u, parseNDigits as x } from "./ghl-ui.es1671.js";
import b from "./ghl-ui.es1675.js";
var N = /* @__PURE__ */ function(p) {
  h(o, p);
  var s = m(o);
  function o() {
    var t;
    y(this, o);
    for (var r = arguments.length, a = new Array(r), e = 0; e < r; e++)
      a[e] = arguments[e];
    return t = s.call.apply(s, [this].concat(a)), d(l(t), "priority", 90), d(l(t), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]), t;
  }
  return w(o, [{
    key: "parse",
    value: function(r, a, e, n) {
      var c = function(i) {
        var f = Math.floor((i - 1) / 7) * 7;
        return (i + n.weekStartsOn + 6) % 7 + f;
      };
      switch (a) {
        case "c":
        case "cc":
          return u(x(a.length, r), c);
        case "co":
          return u(e.ordinalNumber(r, {
            unit: "day"
          }), c);
        case "ccc":
          return e.day(r, {
            width: "abbreviated",
            context: "standalone"
          }) || e.day(r, {
            width: "short",
            context: "standalone"
          }) || e.day(r, {
            width: "narrow",
            context: "standalone"
          });
        case "ccccc":
          return e.day(r, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return e.day(r, {
            width: "short",
            context: "standalone"
          }) || e.day(r, {
            width: "narrow",
            context: "standalone"
          });
        case "cccc":
        default:
          return e.day(r, {
            width: "wide",
            context: "standalone"
          }) || e.day(r, {
            width: "abbreviated",
            context: "standalone"
          }) || e.day(r, {
            width: "short",
            context: "standalone"
          }) || e.day(r, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 0 && a <= 6;
    }
  }, {
    key: "set",
    value: function(r, a, e, n) {
      return r = b(r, e, n), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), o;
}(v);
export {
  N as StandAloneLocalDayParser
};
